import { useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { bindActionCreators } from "redux";
import { withToast } from "../../../contexts/toastr.context";
import { Community } from "../../../types/community/community.type";
import { User } from "../../../types/user/minimal-user.type";
import { TabBody } from "../../../_components/atoms/tab-body.component";
import { TabPills } from "../../../_components/atoms/tab-pills.component";
import { history } from "../../../_config";
import { setCommunity } from "../../../_store/_actions/community.actions";
import KarmaPointsTab from "./karma-points.tab";

const tabs = [
  { label: "Karma Points", key: "karma-points" },
  { label: "Badges", key: "badges" },
];

interface CommunitySettingsLeaderboardRelatedPageProps {
  user: User;
  community: Community;
  addToast: any;
  updateUserProfile: (profile: any) => void;
}
export const COMMUNITY_SETTING_LEADERBOARD_RELATED_PAGE_ROUTE =
  "/settings/leaderboard-related/:tabPath";

export const getCommunitySettingLeaderboardRelatedPageLink = (
  tabPath?: string
) => `/settings/leaderboard-related/${tabPath ?? tabs[0].key}`;

export function CommunitySettingsLeaderboardRelatedPageComponent({
  user,
  community,
  addToast,
  updateUserProfile = (e) => {},
}: CommunitySettingsLeaderboardRelatedPageProps) {
  const [welcomeMessagesOn, setWelcomeMessagesOn] = useState(true);
  const [welcomeMessages, setWelcomeMessages] = useState(
    community.welcomeMessages
  );

  const { tabPath } = useParams<{ tabPath: string }>();
  console.log({ tabPath });
  const [selectedTab, setSelectedTab] = useState(tabPath);

  return (
    <div className="UserWallPage flex rounded pensil-card shadow">
      <div className="main-content theme-bg-surface">
        {/* header card */}
        <div className="theme-bg-surface p-4 pb-0 border-b theme-border-default lex items-start justify-between">
          <div className="font-bold theme-text-heading-2">
            Leaderboard & Badges
          </div>
          <div className="pt-2">
            <div>
              <TabPills
                selectedTab={selectedTab}
                setSelectedTab={(tabPath: string) => {
                  history.push(
                    getCommunitySettingLeaderboardRelatedPageLink(tabPath)
                  );
                  setSelectedTab(tabPath);
                }}
                tabs={tabs}
              />
            </div>
          </div>
        </div>

        <TabBody
          //@ts-ignores
          selectedTab={selectedTab}
          components={{ "karma-points": <KarmaPointsTab /> }}
        />
      </div>
    </div>
  );
}

const CommunitySettingsLeaderboardRelatedPage = withToast(
  connect(
    (s: any) => ({
      community: s.community,
      user: s.auth,
    }),
    (d: any) =>
      bindActionCreators(
        {
          updateCommunity: setCommunity,
        },
        d
      )
  )(CommunitySettingsLeaderboardRelatedPageComponent)
);

export default CommunitySettingsLeaderboardRelatedPage;
